<template>
  <div id="app">
    <!-- <v-app id="inspire"> -->
      <!-- <v-content> -->
      <v-container fluid class="gradientBack">
        <v-layout align-center justify-center mt-5>
          <v-flex xs12 sm10 md4>
            <v-img 
              :src="require('@/assets/img/logo-ittention.png')"
              max-width="30%"
              class="mx-auto mb-5 mt-5"
            ></v-img>
            <div class="p-4"></div>
            <v-form @submit.prevent="handleSubmit" tex>
              <v-layout row wrap md-5>
                  <v-text-field
                    prepend-icon="person_outline"
                    name="login"
                    :label="$t('placeholders.username')"
                    type="text"
                    v-model="username"
                    class="px-5"
                  ></v-text-field>
                  <v-text-field
                    prepend-icon="lock_outline"
                    name="password"
                    :label="$t('placeholders.password')"
                    id="password"
                    type="password"
                    v-model="password"
                    class="px-5"
                  ></v-text-field>
                <!-- <v-layout align-center>
                      <v-checkbox v-model="remember_me">
                        <div slot="label">Remember Me</div>
                      </v-checkbox>
                      <a href="reset" class="font-weight-light font-italic">Forgot Password?</a>
                </v-layout>-->
              </v-layout>
              <v-layout justify-center my-5 no-outline>
                <v-btn small type="submit" v-ripple="false">
                  <flatHex/>
                  <p class="hex_polygon_text">{{$t('buttons.login')}}</p>
                </v-btn>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- </v-content> -->
    <!-- </v-app> -->
  </div>
</template>

<script>
import flatHex from "../../components/icons/flat-hex.vue";

export default {
  props: { source: String },
  mounted: function() {
    this.remember_me = this.isRemember;
  },
  data() {
    return {
      drawer: null,
      username: "",
      password: "",
      submitted: false,
      remember_me: false,
    };
  },
  components: {
    flatHex
  },
  computed: {
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
    getInitialstate() {
      return this.$store.getters["authentication/getStatus"];
    },
    isRemember() {
      return this.$store.getters["authentication/isRememberMe"];
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      const { username, password, remember_me } = this;
      const { dispatch } = this.$store;
      if (username && password) {
        dispatch("authentication/login", { username, password, remember_me });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.gradientBack {
  // background: linear-gradient(to bottom, #50b6e5, #81be6f) !important;
}
.gradientBottomL {
  // background: linear-gradient(0.25turn, rgb(119, 186, 134));
}
.gradientBottomR {
  // color: #50b6e5 !important;
}
.bords,
.elevation-12 {
  border-radius: 0.3rem !important;
}
.fonts {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.hex_polygon_text {
  z-index: 5;
  position: absolute;
}
</style>
